export default __webpack_public_path__ + "static/media/4236.13b10dd0.png";